import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import styles from './FamilyAccess.module.scss';
import WardsList from './components/WardList';
import GuardiansList from './components/GuardiansList';
import { ANY, WARD } from './constants';
import Loading from 'components/Loading';
import { REP } from 'modules/Profile/components/FamilyAccess/constants';

const PAGE_SIZE = 10;

class FamilyAccess extends React.PureComponent {
  state = {
    pagination: { page: 0, size: PAGE_SIZE },
    sortOrder: [],
  };

  componentDidMount() {
    const { getRelations } = this.props;
    const { pagination } = this.state;
    getRelations(pagination);
  }

  fetchNextPage = (values = {}) => {
    const { getRelations } = this.props;
    const { pagination: currentPagination, sortOrder } = this.state;

    const pagination = {
      ...currentPagination,
      ...values,
      sort: sortOrder.map(({ id, desc }) => `${id},${desc ? 'DESC' : 'ASC'}`),
    };

    getRelations(pagination);
    this.setState({ pagination });
  };

  onSortedChange = (sortOrder) => {
    this.setState({ sortOrder }, this.fetchNextPage);
  };

  render() {
    const { user, relations, isLoading, getUserInfo } = this.props;
    const { sortOrder } = this.state;
    const possibleSign = user.getIn(['possibleSign']);
    const relationSign = user.getIn(['relationSign']);

    const isWardOnly = relationSign === WARD || possibleSign === WARD;
    const canAdd = (possibleSign === ANY && relationSign !== WARD) || possibleSign === REP;

    return (
      <div className={`${styles.content} boo`}>
        {isLoading ? (
          <Loading />
        ) : isWardOnly ? (
          <GuardiansList
            relations={relations}
            fetchNextPage={this.fetchNextPage}
            onSortedChange={this.onSortedChange}
            defaultSorted={sortOrder}
            getUserInfo={getUserInfo}
            possibleSign={possibleSign}
          />
        ) : (
          <WardsList
            relations={relations}
            canAdd={canAdd}
            fetchNextPage={this.fetchNextPage}
            onSortedChange={this.onSortedChange}
            defaultSorted={sortOrder}
          />
        )}
      </div>
    );
  }
}

FamilyAccess.propTypes = {
  user: PropTypes.instanceOf(Map),
  relations: PropTypes.instanceOf(Map),
  isLoading: PropTypes.bool,
  getRelations: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func,
};

export default FamilyAccess;
